<mat-card class="cardWithShadow theme-card">

  <mat-card-header>
    <mat-card-title>Nueva Operación</mat-card-title>
    <button mat-icon-button (click)="closeDialog()" style="position: absolute; right: 10px">
        <mat-icon>close</mat-icon>
    </button>
  </mat-card-header>

  <mat-divider style="margin-top: 20px;"></mat-divider>

  <h2 style="text-align: center"></h2>
  <form
    class="form_operation"
    [formGroup]="form"
    (ngSubmit)="submit()"
  >

    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Tasa</mat-label>
      <input matInput formControlName="rate"
      (keyup)="changeCalculationInput()"
      mask="separator"
      thousandSeparator="."
      />
      <mat-icon matSuffix>percent</mat-icon>
      <mat-hint *ngIf="f['rate'].touched && f['rate'].invalid" class="error-msg">
        <div
          class="text-error"
          *ngIf="f['rate'].errors && f['rate'].errors['required']"
        >
          Este Campo es requerido
        </div>
        <div class="text-error" *ngIf="f['rate'].errors['min']">Valor invalido</div>
      </mat-hint>
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Porcentaje de Pago Inicial</mat-label>
      <input type="number" matInput 
      decimalMarker=","
      formControlName="downPaymentPercentage" 
      (keyup)="changeCalculationInput()"
      />
      <mat-icon matSuffix>percent</mat-icon>
      
      <mat-hint
        *ngIf="
          f['downPaymentPercentage'].touched && f['downPaymentPercentage'].invalid
        "
        class="error-msg"
      >
        <div
          class="text-error"
          *ngIf="
            f['downPaymentPercentage'].errors &&
            f['downPaymentPercentage'].errors['required']
          "
        >
          Este Campo es requerido
        </div>
        <div class="text-error" *ngIf="f['downPaymentPercentage'].errors['min']">Valor invalido</div>
        <div class="text-error" *ngIf="f['downPaymentPercentage'].errors['max']">Porcentaje superior al 100%</div>
      </mat-hint>
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Plazo</mat-label>
      <input type="number" matInput formControlName="plazo" (keyup)="changeCalculationInput()"/> <span style="position: absolute; margin-left: -20px; font-weight: bold;">Dias</span>
      <mat-hint class="error-msg" *ngIf="f['plazo'].touched && f['plazo'].invalid">
        <div class="text-error" *ngIf="f['plazo'].errors && f['plazo'].errors['required']">
          Este campo es requerido
        </div>
        <div class="text-error" *ngIf="f['plazo'].errors && f['plazo'].errors['min']">
          Valor invalido
        </div>
      </mat-hint>
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Costos Operativos</mat-label>
      <input
        matInput
        mask="separator"
        thousandSeparator="."
        decimalMarker=","
        formControlName="operationalCost"
        (keyup)="changeCalculationInput()"
      />
      <mat-icon matSuffix>attach_money</mat-icon>
      <mat-hint
        *ngIf="f['operationalCost'].touched && f['operationalCost'].invalid"
        class="error-msg"
      >
        <div
          class="text-error"
          *ngIf="
            f['operationalCost'].errors && f['operationalCost'].errors['required']
          "
        >
          Este Campo es requerido
        </div>
      </mat-hint>
    </mat-form-field>


    <div class="container-comment">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Comentarios</mat-label>
        <textarea matInput formControlName="comments"></textarea>
        <mat-hint
          *ngIf="f['comments'].touched && f['comments'].invalid"
          class="error-msg"
        >
          <div
            class="text-error"
            *ngIf="f['comments'].errors && f['comments'].errors['required']"
          >
            Este Campo es requerido
          </div>
        </mat-hint>
      </mat-form-field>
    
    </div>

    <div class="w-100">
      <mat-label style="font-weight: bold;">Precio Diferencia</mat-label>
      <p>
        {{ 
          factoringCalculation?.priceDifference
            ? (factoringCalculation?.priceDifference | currency:'CLP':'symbol')
            : "-" 
        }}
      </p>
    </div>

    <div class="w-100">
      <mat-label style="font-weight: bold;">Tasa Total</mat-label>
      <p>
        {{ 
          factoringCalculation?.allInRate
            ? (factoringCalculation?.allInRate + '%')
            : "-" 
        }}
      </p>
    </div>

    <div class="w-100">
      <mat-label style="font-weight: bold;">Impuesto sobre costo operativo</mat-label>
      <p>
        {{ 
          factoringCalculation?.operationalCostTax
            ? (factoringCalculation?.operationalCostTax | currency:'CLP':'symbol')
            : "-" 
        }}
      </p>
    </div>

    <div class="w-100" >
      <mat-label style="font-weight: bold;">Monto Financiamiento</mat-label>
      <p>
      {{
        factoringCalculation?.financedAmount
        ? (factoringCalculation?.financedAmount | currency:'CLP':'symbol')
        : "-" 
      }}      
      </p>
    </div>

    <div class="w-100">
      <mat-label style="font-weight: bold;">Monto de Transferencia</mat-label>
      <p>
        {{
          factoringCalculation?.transferAmount
          ? (factoringCalculation?.transferAmount | currency:'CLP':'symbol')
          : "-" 
        }}
      </p>
    </div>

    <div class="container_button">
      <button type="button" mat-flat-button color="secondary" [disabled]="!isValidToCalculate()" (click)="calculateOperation()">
        Calcular
      </button>
      <button mat-flat-button color="primary" [disabled]="!form.valid || isCalculationRequired">
        Registrar
      </button>
    </div>
  </form>
</mat-card>
